var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',{attrs:{"for":"subject in subjects"}},_vm._l((_vm.subjects),function(subject){return _c('fragment',{key:subject._uid},[(subject.type === 'insurer')?_c('insurer-headers'):_vm._e(),(subject.type === 'indemnity')?_c('indemnity-headers'):_vm._e(),(subject.type === 'rates')?_c('rates-headers'):_vm._e()],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }